<template>
  <div class="unreport-link">
    <div class="link" @click="unreportCommunity()">
      <span>{{ $t('administrator.unreportCommunity.unreport') }}</span>
    </div>
    <modal-confirm
      class="confirm-unreport"
      @click.stop
      @confirm="unreport()"
      @close="closeModal()"
      :cancel="$t('administrator.unreportCommunity.no')"
      :confirm="$t('administrator.unreportCommunity.yes')"
      :title="$t('administrator.unreportCommunity.unreportCommunity')"
      :message="$t('administrator.unreportCommunity.unreportConfirmation')"
      :show-modal="showModal"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'UnreportCommunity',
  components: { ModalConfirm },
  props: {
    communityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    unreportCommunity () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    async unreport () {
      this.closeModal()
      let message = this.$t('administrator.unreportCommunity.communityUnreported')
      let success = await this.$store.dispatch('unreportCommunity', this.communityId)
      if (success) {
        this.$toasted.global.success(message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .unreport-link {
    width: 100%;
    .link {
        color: $primary-color;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -ms-flex-pack: start;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 14px;

        &:hover  {
          cursor: pointer;
          background-color: $primary-color;
          color: white;
        }
      }
  }
</style>
